export default __webpack_public_path__ + "static/media/room-cleaner.be0fb920.svg";